import { PlaceHolder } from "@/services/smsPlaceHolders/type";
import replacePlaceholders from "@/utilities/helper/replacedPlaceholders";
import { Skeleton, Text, TextProps } from "@mantine/core";

interface Props extends TextProps {
  text: string;
  tags: PlaceHolder[];
  preview?: boolean;
  isLoading?: boolean;
}

function TagReplacer({ text, tags, isLoading, preview, ...props }: Props) {
  const replacedText = replacePlaceholders(text, tags, preview);
  return isLoading ? (
    <Skeleton h={10} />
  ) : (
    <Text {...props}>
      <div dangerouslySetInnerHTML={{ __html: replacedText }} />
    </Text>
  );
}

export default TagReplacer;
